import cn from "classnames";
import Image from "next/image";
import { Rating } from "./Rating";
import styles from "./ReviewItem.module.scss";
import { Fragment } from "react";

const icons = {
  studycrumb: {
    name: "StudyCrumb",
    full: {
      width: 19,
      height: 16,
      src: "studycrumb.svg",
    },
    short: {
      width: 19,
      height: 16,
      src: "studycrumb.svg",
    },
  },
  trustpilot: {
    name: "Trustpilot",
    slug: "trustpilot",
    full: {
      width: 82,
      height: 20,
      src: "trustpilot-full.svg",
    },
    short: {
      width: 24,
      height: 23,
      src: "trustpilot.svg",
    },
  },
  reviews: {
    name: "Reviews.io",
    slug: "reviews",
    full: {
      width: 103,
      height: 16,
      src: "reviews-io-full.png",
    },
    short: {
      width: 24,
      height: 24,
      src: "reviews-io.png",
    },
  },
  sitejabber: {
    name: "Smartcustomer",
    slug: "sitejabber",
    full: {
      width: 120,
      height: 20,
      src: "sitejabber-full.svg",
    },
    short: {
      width: 34,
      height: 34,
      src: "sitejabber.svg",
    },
  },
};

export type ReviewType = "studycrumb" | "trustpilot" | "reviews" | "sitejabber";

type ReviewItemProps = {
  className?: string;
  tag?: "div" | "li";
  type: ReviewType;
  rate?: number;
  link?: string;
};

export const ReviewItem = ({ className, tag, rate, type, link }: ReviewItemProps) => {
  const Tag = tag || "div";

  const icon = icons[type];

  const LinkWrapper = link ? "a" : Fragment;

  const linkWrapperProps = link
    ? {
        href: link,
        target: "_blank",
        rel: "nofollow",
      }
    : {};

  return (
    <Tag className={cn(styles.reviewItem, className)}>
      <LinkWrapper {...linkWrapperProps}>
        <div className={styles.icon}>
          <Image
            src={`/img/misc/reviews/${icon.short.src}`}
            alt=""
            width={icon.short.width}
            height={icon.short.height}
          />
        </div>
        <div className={styles.description}>
          <div>{icons[type].name}</div>
          {rate && <Rating rating={rate} />}
        </div>
      </LinkWrapper>
    </Tag>
  );
};
